module.exports = __webpack_public_path__ + "img/hc.8741cf1b.svg";